import { useState, useEffect } from 'react';

export default function OfflineBanner() {
  const [offline, setOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const goOffline = () => setOffline(true);
    const goOnline  = () => setOffline(false);
    window.addEventListener('offline', goOffline);
    window.addEventListener('online',  goOnline);
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online',  goOnline);
    };
  }, []);

  if (!offline) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 9999,
      background: '#d4a84a',
      color: '#0a0f1a',
      textAlign: 'center',
      padding: '7px 16px',
      fontSize: 13,
      fontWeight: 600,
      letterSpacing: 0.1,
      pointerEvents: 'none',
    }}>
      You're offline — showing cached data
    </div>
  );
}
